/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {Box, Typography, IconButton} from '@material-ui/core';
import TextField from '../../components/fields/Text';
import {
  ShoppingCart as ShoppingCartIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Search as SearchIcon,
  Close as CloseIcon,
} from '@material-ui/icons';
import {useSelector, useDispatch} from 'react-redux';
import {SELECTOR_PRODUCT_PRICE_LIST, SELECTOR_PRODUCT_PRICE_LIST_TOTALS} from '../../redux/selectors/productPriceList';
import {getProductPriceList, updateInternalCode} from '../../redux/actions/productPriceList';
import {addToShoppingCart} from '../../redux/actions/shoppingCart';
import {Table, Pagination} from 'antd';
import numeral from 'numeral';
import {getPicture} from '../../modules/imageHandler';
import {useHistory, useLocation} from 'react-router';
import {addNotification, setProductSelected} from '../../redux/actions';
import api from '../../services/api';

export default function MyProducts() {
  const [listLength] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [edit, setEdit] = useState(0);
  const [code, setCode] = useState({});
  const [searchCode, setSearchCode] = useState('');
  const [isSearch, setIsSearch] = useState(false);

  const productPriceList = useSelector(SELECTOR_PRODUCT_PRICE_LIST);
  const pagination = useSelector(SELECTOR_PRODUCT_PRICE_LIST_TOTALS);
  const integrationId = useSelector((state) => state.auth.user?.company?.price_list?.integration_id);

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  function _fetchData(skip, search) {
    if (fetching) return;
    setFetching(true);
    dispatch(
      getProductPriceList({
        query: {
          integration_list: integrationId,
          ...(search ? {q: search} : {}),
          $skip: skip,
          $limit: listLength,
        },
      }),
    ).finally(() => setFetching(false));
  }

  function quickView(id, slug) {
    history.push(`/mi-cuenta/mis-productos/quick-view${slug.substring(1)}${location.search}`);
    dispatch(setProductSelected(id));
  }

  async function saveCode(item) {
    const updateCallback = () => {
      const data = {
        ...item,
        product: {
          ...item.product,
          internal_code: code[item.product.id],
        },
      };
      dispatch(updateInternalCode(data));
      setEdit(0);
      setCode('');
    };
    if (item.product.company_internal_code_id) {
      await api.companiesProductInternalCode
        .patch(item.product.company_internal_code_id, {internal_code: code[item.product.id]})
        .then(() => {
          updateCallback();
          dispatch(addNotification('Se ha actualizado el código interno', 'success'));
        })
        .catch((e) => {
          addNotification(e.message, 'error');
          setEdit(0);
          setCode('');
        });
    } else {
      await api.companiesProductInternalCode
        .create({internal_code: code[item.product.id], product_integration_id: item.integration_id})
        .then((e) => {
          updateCallback();
          dispatch(addNotification('Se asignado el código interno.', 'success'));
        })
        .catch((e) => {
          dispatch(addNotification(e.message, 'error'));
          setEdit(0);
          setCode('');
        });
    }
  }

  function handleSearch() {
    if (isSearch) history.push({search: '?page=1'});
    else {
      const query = new URLSearchParams();
      query.set('page', 1);
      searchCode && query.set('search', searchCode);
      history.push({search: query.toString()});
    }
  }

  const columns = [
    {
      render: (v) => (
        <img
          style={{cursor: 'pointer'}}
          onClick={() => quickView(v.product.id, v.product.slug)}
          src={getPicture(!!v.product?.media?.length ? v.product.media[0].path : '', 612, 612)}
          width="50"
          height="50"
          alt="product"
        />
      ),
    },
    {
      title: 'Producto',
      render: (v) => (
        <Typography style={{cursor: 'pointer'}} onClick={() => quickView(v.product.id, v.product.slug)}>
          {v.product.name}
        </Typography>
      ),
    },
    {
      title: 'Valor',
      dataIndex: 'price_with_tax',
      render: (v) => numeral(v).format('$ 0,000'),
    },
    {
      title: 'Código interno',
      render: (v) =>
        !v.product.internal_code || edit === v.product.id ? (
          <Box display="flex" alignItems="center">
            <TextField
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
              label="Ingrese el código"
              value={code[v.product.id]}
              onChange={(e) => {
                const {value} = e.target;
                setCode((prev) => ({...prev, [v.product.id]: value}));
              }}
            />
            <IconButton color="default" onClick={() => saveCode(v)}>
              <SaveIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Box>
            {v.product.internal_code}
            <IconButton
              color="primary"
              onClick={() => {
                setEdit(v.product.id);
                setCode((prev) => ({...prev, [v.product.id]: v.product.internal_code}));
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
        ),
    },
    {
      render: (v) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <IconButton color="primary" onClick={() => quickView(v.product.id, v.product.slug)}>
            <RemoveRedEyeIcon fontSize="small" />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => dispatch(addToShoppingCart({productId: v.product.id, quantity: 1}))}
          >
            <ShoppingCartIcon fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const page = Number(searchParams.get('page') || '1');
    const search = searchParams.get('search');
    setSearchCode(search);
    setIsSearch(!!search);
    setCurrentPage(page);
    _fetchData((page - 1) * listLength, search);
  }, [location.search]);

  return (
    <Box>
      <Box mb={2}>
        <Typography component="h2" variant="subtitle1">
          Mis productos
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" mb={2}>
        <div style={{maxWidth: 350}}>
          <TextField
            type="search"
            label="Buscar por código interno"
            InputLabelProps={{
              shrink: true,
            }}
            value={searchCode}
            onChange={(e) => {
              setSearchCode(e.target.value);
              isSearch && setIsSearch(false);
              const q = new URLSearchParams(location.search);
              if (!e.target.value && !!q.get('search')) history.push({search: '?page=1'});
            }}
          />
        </div>
        <Box ml={1}>
          <IconButton color="primary" onClick={handleSearch}>
            {isSearch ? <CloseIcon fontSize="small" /> : <SearchIcon fontSize="small" />}
          </IconButton>
        </Box>
      </Box>
      <Table
        columns={columns}
        loading={fetching}
        rowKey={(item) => item.id}
        pagination={false}
        dataSource={productPriceList}
      />
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Pagination
          defaultCurrent={currentPage}
          current={currentPage}
          total={pagination.total}
          showSizeChanger={false}
          defaultPageSize={listLength}
          onChange={(current) => {
            const q = new URLSearchParams(location.search);
            q.set('page', current);
            history.push({search: q.toString()});
            window.scrollTo(0, 0);
          }}
        />
      </Box>
    </Box>
  );
}
